export const COMPOUND_MODAL_FEE = 0.2;
export const COMPOUND_MODAL_SLIPPAGE = 1;
